import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import CertificadosTable from "./CertificadosTable";
import SolicitudesTable from "./SolicitudesTable";
import HonorariosDashboard from "./HonorariosDashboard";
import Typography from "@mui/material/Typography";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`honorarios-tabpanel-${index}`}
            aria-labelledby={`honorarios-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

export default function HonorariosHome() {
    const location = useLocation();
    const [value, setValue] = useState(0);
    const solicitudesRef = useRef();

    // Check if we need to navigate to a specific tab
    useEffect(() => {
        if (location.state?.activeTab !== undefined) {
            setValue(location.state.activeTab);
        }
    }, [location]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleSolicitudCreated = () => {
        // Switch to Solicitudes tab (now index 2)
        setValue(2);
        // Trigger refresh on Solicitudes table
        if (solicitudesRef.current && solicitudesRef.current.refresh) {
            solicitudesRef.current.refresh();
        }
    };

    return (
        <div>
            <Paper sx={{
                flexGrow: 1,
                width: "100%",
                bgcolor: "background.paper",
                borderRadius: '4px',
                overflow: 'hidden',
            }}>
                <Box sx={{
                    background: "linear-gradient(135deg, #2e7d32 0%, #4CAF50 100%)",
                    px: 3,
                    py: 1.5,
                }}>
                    <Typography variant="h6" sx={{ color: "#fff", fontWeight: 600 }}>
                        Gestión de Honorarios
                    </Typography>
                    <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                        Consulte sus certificados y genere solicitudes de pago
                    </Typography>
                </Box>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Dashboard" />
                    <Tab label="Certificados Pendientes" />
                    <Tab label="Solicitudes de Pago" />
                </Tabs>
                <TabPanel value={value} index={0}>
                    <HonorariosDashboard />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <CertificadosTable onSolicitudCreated={handleSolicitudCreated} />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <SolicitudesTable ref={solicitudesRef} />
                </TabPanel>
            </Paper>
        </div>
    );
}
